<template>
  <div>
    <b-overlay :show="loading">

      <b-row>
        <b-col
            v-if="ticket"
            md="8"
            lg="8"
        >
          <b-card
              :id="`ticket-${ticket.id}`"
              :ref="`ticket${ticket.id}`"
              class="mb-4 card-app-design"
          >
            <b-card-header class="pb-1">

              <b-media no-body>
                <b-media-body>
                  <h5 class="mb-0">
                    {{ ticket.creator.name }}
                  </h5>
                  <small class="text-muted">{{ ticket.createdDate }}</small>
                </b-media-body>
                <b-badge
                    pill
                    :variant="ticket.priority.label"
                ><small>{{
                    ticket.priority.title
                  }}</small></b-badge>
              </b-media>
              <span class="text-muted"> شماره نامه: {{ ticket.mainId }}</span>
              <b-button
                  :variant="`outline-${closeVariant}`"
                  size="sm"
                  :disabled="ticket.isClosed"
                  @click="closeTicket"
              >
                {{ closeButtonText }}
              </b-button>
            </b-card-header>

            <b-card-title class="mt-1 mb-75">
              عنوان: {{ ticket.title }}

            </b-card-title>

            <b-card-text v-html="ticket.content"/>
            <div class="demo-inline-spacing">
              <b-button
                  v-if="ticket.id == ticket.mainId"
                  variant="outline-success"
                  size="sm"
                  @click="setTicketId(ticket.id,'showReplyModal')"
              >
                پاسخ به پیام اصلی
              </b-button>

              <!-- select 2 demo -->
              <b-button
                  class="mr-2"
                  variant="outline-primary"
                  size="sm"
                  @click="setTicketId(ticket.id,'showForwardModal')"
              >
                ارجاع پیام اصلی
              </b-button>
            </div>
            <b-card-footer v-if="ticket.attachments && ticket.attachments.length">
              <div class="mail-attachments mt-1">
                <div class="d-flex align-items-center mb-1">
                  <feather-icon
                      icon="PaperclipIcon"
                      size="16"
                  />
                  <h5 class="font-weight-bolder text-body mb-0 ml-50">
                    فایل{{ ticket.attachments.length > 1 ? ' ها' : '' }} {{ ticket.attachments.length }}
                  </h5>
                </div>

                <div class="d-flex flex-column">
                  <b-link
                      v-for="(attachment, index) in ticket.attachments"
                      :key="index"
                      :href="attachment.url"
                      target="_blank"
                      :class="{'mt-75': index}"
                  >
                    <!--                  <b-img-->
                    <!--                      :src="attachment.thumbnail"-->
                    <!--                      width="16px"-->
                    <!--                      class="mr-50"-->
                    <!--                  />-->
                    <span class="text-muted font-weight-bolder align-text-top">{{ attachment.fileName }}</span>
                    <span class="text-muted font-small-2 ml-25">({{ attachment.size }})</span>
                  </b-link>
                </div>
              </div>
            </b-card-footer>

          </b-card>
        </b-col>
      </b-row>
      <b-row>

        <b-col
            md="7"
            lg="7"
        >
          <div ref="repliesList">
            <b-card
                v-for="message in tickets"
                :id="`ticket-${message.id}`"
                :ref="`ticket${message.id}`"
                :key="message.id"
                no-body
                class="mb-4"
            >
              <b-card-header
                  class="email-detail-head"
              >
                <div class="user-details d-flex justify-content-between align-items-center flex-wrap">
                  <b-avatar
                      size="48"
                      :show="message.creator.avatar"
                      :src="message.creator.avatar"
                      class="mr-75"
                  />
                  <div class="mail-items">
                    <h5 class="mb-0">
                      {{ `${message.type.title} توسط: ${message.creator.name}` }}
                    </h5>
                    <header class="blockquote-footer cursor-pointer" @click="scrollTo(`ticket${message.parent.id}`)">
                      <small title="ارجاع از">{{ message.parent.creator.name }}: <cite>{{
                          message.parent.content
                        }}</cite></small>
                    </header>
                  </div>
                </div>
                <div class="mail-meta-item d-flex align-items-center">
                  <!-- Mail Action DD -->
                  <div class="demo-inline-spacing">
                    <small class="mail-date-time text-muted">
                      <bdi>{{ message.createdDate }}</bdi>
                    </small>
                    <b-button
                        v-if="message.showReplyButton"
                        variant="outline-success"
                        size="sm"
                        @click="setTicketId(message.id,'showReplyModal')"
                    >
                      پاسخ
                    </b-button>

                    <!-- select 2 demo -->
                    <b-button
                        class="mr-2"
                        variant="outline-primary"
                        size="sm"
                        @click="setTicketId(message.id,'showForwardModal')"
                    >
                      ارجاع
                    </b-button>
                  </div>
                </div>
              </b-card-header>

              <b-card-body class="mail-message-wrapper pt-2">
                <!-- eslint-disable vue/no-v-html -->
                <div
                    class="mail-message"
                    v-html="message.content"
                />
                <!-- eslint-enable -->
              </b-card-body>

              <b-card-footer v-if="message.attachments && message.attachments.length">
                <div class="mail-attachments">
                  <div class="d-flex align-items-center mb-1">
                    <feather-icon
                        icon="PaperclipIcon"
                        size="16"
                    />
                    <h5 class="font-weight-bolder text-body mb-0 ml-50">
                      فایل {{ message.attachments.length > 1 ? 'ها' : '' }} {{ message.attachments.length }}
                    </h5>
                  </div>

                  <div class="d-flex flex-column">
                    <b-link
                        v-for="(attachment, index) in message.attachments"
                        :key="index"
                        :href="attachment.url"
                        target="_blank"
                        :class="{'mt-75': index}"
                    >

                      <span class="text-muted font-weight-bolder align-text-top">{{ attachment.fileName }}</span>
                      <span class="text-muted font-small-2 ml-25">({{ attachment.size }})</span>
                    </b-link>
                  </div>
                </div>
              </b-card-footer>
            </b-card>

            <!--          <b-card class="mb-4" v-for="message in tickets"-->
            <!--                  :ref="`ticket${message.id}`"-->
            <!--                  :id="`ticket-${message.id}`"-->
            <!--                  :key="message.id"-->
            <!--                  :sub-title="`${message.type.title} توسط: ${message.creator.name} در تاریخ ${message.createdDate}`">-->
            <!--            <blockquote class="blockquote border p-1 cursor-pointer" @click="scrollTo(`ticket${message.parent.id}`)">-->
            <!--              <header class="blockquote-footer">-->
            <!--                <cite title="" v-html="message.parent.content"></cite>-->
            <!--              </header>-->
            <!--            </blockquote>-->
            <!--            <b-card-text v-html="message.content">-->
            <!--            </b-card-text>-->

            <!--            <div class="demo-inline-spacing float-right">-->
            <!--              <b-button-->
            <!--                  variant="outline-success"-->
            <!--                  @click="setTicketId(message.id,'showReplyModal')"-->
            <!--                  size="sm"-->

            <!--              >-->
            <!--                پاسخ به پیام-->
            <!--              </b-button>-->

            <!--              &lt;!&ndash; select 2 demo &ndash;&gt;-->
            <!--              <b-button-->
            <!--                  class="mr-2"-->
            <!--                  variant="outline-primary"-->
            <!--                  @click="setTicketId(message.id,'showForwardModal')"-->
            <!--                  size="sm"-->
            <!--              >-->
            <!--                ارجاع پیام-->
            <!--              </b-button>-->
            <!--            </div>-->

            <!--            <b-card-footer v-if="message.attachments && message.attachments.length">-->
            <!--              <div class="mail-attachments mt-1">-->
            <!--                <div class="d-flex align-items-center mb-1">-->
            <!--                  <feather-icon-->
            <!--                      icon="PaperclipIcon"-->
            <!--                      size="16"-->
            <!--                  />-->
            <!--                  <h5 class="font-weight-bolder text-body mb-0 ml-50">-->
            <!--                    فایل{{ message.attachments.length > 1 ? ' ها' : '' }} {{ message.attachments.length }}-->
            <!--                  </h5>-->
            <!--                </div>-->

            <!--                <div class="d-flex flex-column">-->
            <!--                  <b-link-->
            <!--                      v-for="(attachment, index) in message.attachments"-->
            <!--                      :key="index"-->
            <!--                      :href="attachment.url"-->
            <!--                      target="_blank"-->
            <!--                      :class="{'mt-75': index}"-->
            <!--                  >-->
            <!--                    &lt;!&ndash;                  <b-img&ndash;&gt;-->
            <!--                    &lt;!&ndash;                      :src="attachment.thumbnail"&ndash;&gt;-->
            <!--                    &lt;!&ndash;                      width="16px"&ndash;&gt;-->
            <!--                    &lt;!&ndash;                      class="mr-50"&ndash;&gt;-->
            <!--                    &lt;!&ndash;                  />&ndash;&gt;-->
            <!--                    <span class="text-muted font-weight-bolder align-text-top">{{ attachment.fileName }}</span>-->
            <!--                    <span class="text-muted font-small-2 ml-25">({{ attachment.size }})</span>-->
            <!--                  </b-link>-->
            <!--                </div>-->
            <!--              </div>-->
            <!--            </b-card-footer>-->

            <!--          </b-card>-->

          </div>
          <!--        </b-overlay>-->
        </b-col>
      </b-row>

      <b-row>

        <b-col
            md="8"
            lg="6"
        >

          <!-- List groups -->
          <h6 class="my-2 text-muted">
            تاریخچه ارجاع ها
          </h6>
          <b-card
              no-body
              class="mb-4"
          >
            <b-list-group flush>
              <template v-for="reference in references">
                <b-list-group-item :key="reference.id">
                  <b-avatar
                      :id="`row-${reference.id}`"
                      size="32"
                      variant="light-info"
                  >
                    <feather-icon
                        :icon="`${reference.type.icon}`"
                    />
                  </b-avatar>
                  {{ reference.text }}
                </b-list-group-item>
                <b-list-group-item
                    v-if="reference.seen_text"
                    :key="`seen_${reference.id}`"
                >
                  <b-avatar
                      :id="`row-${reference.id}`"
                      size="32"
                      variant="light-info"
                  >
                    <feather-icon
                        icon="EyeIcon"
                    />
                  </b-avatar>
                  {{ reference.seen_text }}
                </b-list-group-item>
              </template>
            </b-list-group>
          </b-card>
        </b-col>
      </b-row>
    </b-overlay>

    <b-modal
        id="modal-reply"
        ref="modalReply"
        v-model="showReplyModal"
        :ok-disabled="onProgress"
        cancel-variant="outline-secondary"
        :ok-title="onProgress ? 'در حال ارسال': 'پاسخ'"
        cancel-title="انصراف"
        centered
        title="پاسخ به پیام"
        size="lg"
        @ok="replyForm"
        @cancel="cancelForm"
    >
      <b-form>

        <b-row>
          <b-col md="12">
            <b-form-group
                label="متن پاسخ"
            >
              <div>
                <quill-editor
                    v-model="replyContent"
                    :options="editorOption"
                    style="min-height:150px;"
                />
              </div>

            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group
                :description="`${sms.length}/${maxChar}`"
                label="متن پیامک"
            >
              <div>
                <b-form-textarea
                    id="textarea-state"
                    v-model="sms"
                    :state="sms.length <= 130"
                    placeholder="متن پیامک"
                    rows="3"
                />
              </div>

            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <b-card>
              <b-card-body>
                <b-row
                    v-for="(item, index) in attachment.items"
                    :id="item.id"
                    :key="item.id"
                >
                  <!-- Item Name -->
                  <b-col
                      md="9"
                      lg="9"
                  >
                    <b-form-group>
                      <label :for="`attachment_${item.id}`">
                        <feather-icon
                            icon="PaperclipIcon"
                        />
                        فایل
                      </label>
                      <b-form-file
                          v-model="item.file"
                          placeholder="فایل را انتخاب کنید یا به اینجا بکشید"
                          drop-placeholder="عکس را به اینحا بکشید"
                          no-drop
                      />
                    </b-form-group>
                  </b-col>

                  <!-- Remove Button -->
                  <b-col
                      lg="3"
                      md="3"
                      class="mb-50"
                  >
                    <b-button
                        variant="outline-danger"
                        class="mt-0 mt-md-2"
                        @click="removeItem(index)"
                    >
                      <feather-icon
                          icon="XIcon"
                          class="mr-25"
                      />
                      <span>حذف فایل</span>
                    </b-button>
                  </b-col>
                  <b-col cols="12">
                    <hr>
                  </b-col>
                </b-row>
                <b-button
                    variant="primary"
                    @click="repeateAgain"
                >
                  <feather-icon
                      icon="PlusIcon"
                      class="mr-25"
                  />
                  <span>افزودن فایل</span>
                </b-button>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>
      </b-form>
    </b-modal>

    <b-modal
        id="modal-forward"
        ref="modalForward"
        v-model="showForwardModal"
        :ok-disabled="onProgress"
        title="ارجاع به دیگران"
        :ok-title="onProgress ? 'در حال ارسال': 'ارجاع'"
        cancel-title="انصراف"
        cancel-variant="outline-secondary"
        size="lg"
        @ok="forwardForm"
        @cancel="cancelForm"
    >
      <b-form>

        <b-row>
          <b-col md="12">
            <b-form-group
                label="متن نامه"
            >
              <div>
                <quill-editor
                    v-model="forwardContent"
                    :options="editorOption"
                    style="min-height:150px;"
                />
              </div>

            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group
                :description="`${sms.length}/${maxChar}`"
                label="متن پیامک"
            >
              <div>
                <b-form-textarea
                    id="textarea-state"
                    v-model="sms"
                    :state="sms.length <= 130"
                    placeholder="متن پیامک"
                    rows="3"
                />
              </div>

            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <b-form-group
                label="درجه اهمیت"
            >
              <b-overlay
                  :show="prioritiesList.length === 0"
              >
                <v-select
                    v-model="priority"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :options="prioritiesList"
                    :reduce="priority => priority.id"
                />
              </b-overlay>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
                label="دریافت کنندگان"
            >
              <b-overlay>
                <v-select
                    v-model="receivers"
                    multiple
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="name"
                    :options="receiversList"
                    :reduce="receiver => receiver.id"
                />
              </b-overlay>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-card>
              <b-card-body>
                <b-row
                    v-for="(item, index) in attachment.items"
                    :id="item.id"
                    :key="item.id"
                >
                  <!-- Item Name -->
                  <b-col
                      md="9"
                      lg="9"
                  >
                    <b-form-group>
                      <label :for="`attachment_${item.id}`">
                        <feather-icon
                            icon="PaperclipIcon"
                        />
                        فایل
                      </label>
                      <b-form-file
                          v-model="item.file"
                          placeholder="فایل را انتخاب کنید یا به اینجا بکشید"
                          drop-placeholder="عکس را به اینحا بکشید"
                          no-drop
                      />
                    </b-form-group>
                  </b-col>

                  <!-- Remove Button -->
                  <b-col
                      lg="3"
                      md="3"
                      class="mb-50"
                  >
                    <b-button
                        variant="outline-danger"
                        class="mt-0 mt-md-2"
                        @click="removeItem(index)"
                    >
                      <feather-icon
                          icon="XIcon"
                          class="mr-25"
                      />
                      <span>حذف فایل</span>
                    </b-button>
                  </b-col>
                  <b-col cols="12">
                    <hr>
                  </b-col>
                </b-row>
                <b-button
                    variant="primary"
                    @click="repeateAgain"
                >
                  <feather-icon
                      icon="PlusIcon"
                      class="mr-25"
                  />
                  <span>افزودن فایل</span>
                </b-button>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>

      </b-form>
    </b-modal>
  </div>

</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardHeader,
  BCardBody,
  BForm,
  BFormGroup,
  BFormInput,
  BOverlay,
  BCardTitle,
  BSpinner,
  BButton,
  BCardText,
  BLink,
  BListGroup,
  BListGroupItem,
  BAvatar,
  BBadge,
  BFormTextarea,
  BMediaAside,
  BMedia,
  BMediaBody, BFormFile, BImg, BCardFooter, BDropdown, BDropdownItem,
} from 'bootstrap-vue'
import VSelect from 'vue-select'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import {quillEditor} from 'vue-quill-editor'
import {nextTick} from '@vue/composition-api'
import {formatDate} from '@core/utils/filter'
import {$themeConfig} from '@themeConfig'
import store from '@/store'

export default {
  name: 'TicketDetail',
  components: {
    BDropdownItem,
    BDropdown,
    BCardFooter,
    BImg,
    BFormFile,
    BMediaBody,
    BMedia,
    BMediaAside,
    BFormTextarea,
    BBadge,
    BAvatar,
    BListGroupItem,
    BListGroup,
    BLink,
    BCardText,
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BForm,
    BFormGroup,
    BFormInput,
    BOverlay,
    VSelect,
    BCardTitle,
    BSpinner,
    BButton,
    quillEditor,

  },
  beforeRouteUpdate(to, from, next) {
    if (to.params.id !== from.params.id) {
      this.getTicket(to.params.id)
    }
    next();
  },
  data() {
    return {
      ticket: null,
      tickets: [],
      references: [],
      onProgress: false,
      ticketId: null,
      receivers: [],
      replyContent: '',
      forwardContent: '',
      receiversList: [],
      editorOption: {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            ['blockquote'],
            [{list: 'ordered'}, {list: 'bullet'}],
            [{direction: 'rtl'}],
            [{header: [1, 2, 3, 4, 5, 6, false]}],

            [{color: []}, {background: []}],
            [{align: []}],

            ['clean'],
          ],
        },
        theme: 'snow',
        placeholder: 'متن پیام را وارد کنید',
        clipboard: true,
      },
      sms: '',
      prioritiesList: [],
      priority: '',
      attachment: {
        items: [
          {
            id: 1,
            file: null,
          },
        ],
        nextItemId: 2,
      },
      loading: true,
      maxChar: 140,
      showReplyModal: false,
      showForwardModal: false,
    }
  },
  computed: {
    closeVariant() {
      return this.ticket.isClosed ? 'secondary' : 'danger'
    },
    closeButtonText() {
      return this.ticket.isClosed ? 'بسته شده' : 'بستن نامه'
    },
  },
  mounted() {
    this.getTicket()
    this.getRelatedUsers()
    this.getPriorities()
  },
  methods: {
    repeateAgain() {
      this.attachment.nextItemId++
      this.attachment.items.push({
        id: this.attachment.nextItemId,
        file: null,
      })
    },
    removeItem(index) {
      this.attachment.items.splice(index, 1)
    },
    getTicket(id = null) {
      this.loading = true
      this.$http.get(`tickets/${id ?? this.$route.params.id}`)
          .then(({data}) => {
            if (data.status) {
              this.ticket = data.ticket
              this.tickets = data.tickets
              this.references = data.references
              this.loading = false
            } else {
              this.$bvToast.toast(data.message ?? 'اطلاعات نامه دریافت نشد', {
                title: 'حطا',
                toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
                variant: 'danger',
              })
            }
          })
          .catch(error => {
            this.$bvToast.toast(error.response.data.message ?? 'ارتباط با وبسرویس انجام نشد', {
              title: 'خطا در دریافت اطلاعات',
              toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
              variant: 'danger',
            })
          })

      this.$http.get('tickets/notification?unseen=1')
          .then(({data}) => {
            store.commit('ticket/ADD_TICKETS_TO_LIST', data)
          })
    },

    setTicketId(id, modal) {
      this.ticketId = id
      this[modal] = true
    },
    scrollTo(ref) {
      if (Array.isArray(this.$refs[ref])) {
        this.$refs[ref][0].scrollIntoView({behavior: 'smooth'})
      } else {
        this.$refs[ref].scrollIntoView({behavior: 'smooth'})
      }
    },
    scrollToLastTicket(refName) {
      // this.$nextTick(()=>{
      setTimeout(() => {
        const dynamicContainer = this.$refs.repliesList
        const lastElement = dynamicContainer.lastElementChild
        lastElement.scrollIntoView({behavior: 'smooth'})
      }, 300)

      // })
    },
    async replyForm(bvModalEvt) {
      bvModalEvt.preventDefault()

      this.$refs.modalReply.hide()

      if (this.replyContent === '') {
        this.$bvToast.toast('متن پاسخ نمی تواند خالی باشد', {
          title: 'خطا',
          toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
          variant: 'danger',
        })
        return false
      }

      this.onProgress = true

      const formReplyData = new FormData()

      formReplyData.append('model', 'reply')
      formReplyData.append('reply_id', this.ticketId)
      formReplyData.append('content', this.replyContent)
      formReplyData.append('sms', this.sms)
      if (this.priority) {
        formReplyData.append('priority', this.priority)
      }
      this.receivers.map(receiver => {
        formReplyData.append('receivers[]', receiver)
      })
      this.attachment.items.map(attachment => {
        formReplyData.append('attachments[]', attachment.file)
      })

      await this.$http.post(`tickets/${this.$route.params.id}/reply`, formReplyData, {
        header: [
          'Content-Type:multipart/form-data',
        ],
      })
          .then(({data}) => {
            if (data.status) {
              this.scrollToLastTicket(`ticket${data.reply.id}`)

              this.showReplyModal = false
              this.replyContent = ''
              this.sms = ''
              this.attachment = {
                items: [
                  {
                    id: 1,
                    file: null,
                  },
                ],
                nextItemId: 2,
              }
              this.tickets.push(data.reply)
              this.references = data.references

              this.$bvToast.toast('پاسخ نامه با موفقیت ثبت شد', {
                title: 'انجام درخواست',
                toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
                variant: 'success',
              })
            } else {
              this.$bvToast.toast(data.message ?? 'پاسخ نامه ارسال نشد', {
                title: 'حطا',
                toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
                variant: 'danger',
              })
            }
          })
          .catch(error => {
            this.$bvToast.toast(error.response.data.message ?? `${error.message}`, {
              title: 'خطا در دریافت اطلاعات',
              toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
              variant: 'danger',
            })
          })
          .finally(() => {
            this.onProgress = false
          })
    },

    async forwardForm(bvModalEvt) {
      bvModalEvt.preventDefault()

      if (this.receivers.length === 0) {
        this.$bvToast.toast('کاربران اراجاع دهنده نمی تواند خالی باشد', {
          title: 'خطا',
          toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
          variant: 'danger',
        })
        return false
      }

      this.onProgress = true

      const formForwardData = new FormData()

      formForwardData.append('model', 'forward')
      formForwardData.append('forward_id', this.ticketId)
      formForwardData.append('content', this.forwardContent)
      formForwardData.append('sms', this.sms)
      if (this.priority) {
        formForwardData.append('priority', this.priority)
      }
      this.receivers.map(receiver => {
        formForwardData.append('receivers[]', receiver)
      })
      this.attachment.items.map(attachment => {
        formForwardData.append('attachments[]', attachment.file)
      })

      await this.$http.post(`tickets/${this.$route.params.id}/forward`, formForwardData, {
        header: [
          'Content-Type:multipart/form-data',
        ],
      })
          .then(({data}) => {
            if (data.status) {
              this.showReplyModal = false

              this.forwardContent = ''
              this.sms = ''
              this.attachment = {
                items: [
                  {
                    id: 1,
                    file: null,
                  },
                ],
                nextItemId: 2,
              }
              this.priority = ''

              this.references = data.references

              this.$bvToast.toast('ارجاع با موفقیت ارسال شد', {
                title: 'انجام درخواست',
                toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
                variant: 'success',
              })
            } else {
              this.$bvToast.toast(data.message ?? 'ارجاع ارسال نشد', {
                title: 'حطا',
                toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
                variant: 'danger',
              })
            }
          })
          .catch(error => {
            this.$bvToast.toast(error.response.data.message ?? 'ارتباط با وبسرویس انجام نشد', {
              title: 'خطا در دریافت اطلاعات',
              toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
              variant: 'danger',
            })
          })
          .finally(() => {
            this.onProgress = false
            bvModalEvt.hide()
          })
    },

    getRelatedUsers() {
      this.$http.get('tickets/related-users')
          .then(({data}) => {
            if (data.status) {
              this.receiversList = data.users
            } else {
              this.$bvToast.toast(data.message ?? 'دریافت لیست دریافت کنندگان با خطا مواجه شد', {
                title: 'حطا',
                toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
                variant: 'danger',
              })
            }
          })
          .catch(error => {
            this.$bvToast.toast(error.response.data.message ?? 'ارتباط با وبسرویس انجام نشد', {
              title: 'خطا در دریافت اطلاعات',
              toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
              variant: 'danger',
            })
          })
    },
    getPriorities() {
      this.$http.get('tickets/priorities')
          .then(({data}) => {
            if (data.status) {
              this.prioritiesList = data.priorities
            } else {
              this.$bvToast.toast(data.message ?? 'دریافت لیست اولویت ها با خطا مواجه شد', {
                title: 'حطا',
                toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
                variant: 'danger',
              })
            }
          })
          .catch(error => {
            this.$bvToast.toast(error.response.data.message ?? 'ارتباط با وبسرویس انجام نشد', {
              title: 'خطا در دریافت اطلاعات',
              toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
              variant: 'danger',
            })
          })
    },

    cancelForm() {
      this.replyContent = ''
      this.forwardContent = ''
      this.sms = ''
      this.attachment = {
        items: [
          {
            id: 1,
            file: null,
          },
        ],
        nextItemId: 2,
      }
      this.priority = ''
    },

    closeTicket() {
      this.$swal({
        title: 'هشدار!',
        text: 'از بستن نامه اطمینان دارید؟',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'بله، مطمئنم',
        cancelButtonText: 'منصرف شدم',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      })
          .then(result => {
            if (result.value) {
              this.$http.post(`tickets/${this.ticket.mainId}/close`)
                  .then(({data}) => {
                    if (data.status) {
                      this.ticket.isClosed = true
                      this.$swal({
                        icon: 'success',
                        title: 'بسته شد.',
                        text: 'نامه با موفقیت بسته شد.',
                        customClass: {
                          confirmButton: 'btn btn-success',
                        },
                      })
                    } else {
                      this.$swal({
                        icon: 'error',
                        title: 'خطا!',
                        confirmButtonText: 'متوجه شدم!',
                        text: data.message ?? 'مشکلی در انجام عملیات رخ داده است.',
                        customClass: {
                          confirmButton: 'btn btn-danger',
                        },
                      })
                    }
                  })
            }
          })
    },
  },
  setup() {
    return {
      formatDate,
    }
  },
}
</script>

<style>
.ql-container {
  min-height: inherit;
}

.email-detail-head {
  border-bottom: 1px solid #ebe9f1 !important;
}
</style>
